import { toString, trim } from 'lodash-es';
import * as XLSX from 'xlsx';
import moment from 'moment';

export class SheetFileToJsonService {
    /**
     * Parse excel file and conver to json object
     * @param file The file from file upload event
     */
    public static async parseFile(file: any): Promise<IFileData> {
        const fileData: IFileData = {
            name: file.name,
            size: file.size,
            type: file.type,
            lastModifiedDate: file.lastModifiedDate,
            headers: [],
            data: []
        };

        const reader = new FileReader();
        const promise = new Promise<IFileData>((resolve, reject) => {
            reader.onload = (e) => {
                try {
                    // read workbook
                    const bstr = e.target.result;
                    const wb = XLSX.read(bstr, { type: 'binary', cellDates: true });

                    // read first sheet
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];

                    // read data
                    const raw = XLSX.utils.sheet_to_json(ws, { header: 1, blankrows: false, rawNumbers: true, defval: null });

                    // raw data does not have anything to parse
                    if (raw.length === 0) {
                        resolve(fileData);
                    }

                    fileData.headers = ((raw[0] ?? []) as string[]).map((r) => {
                        const s = trim(toString(r));

                        if (s === '') {
                            return null;
                        }

                        return s;
                    });

                    for (let i = 1; i < raw.length; i++) {
                        const row = fileData.headers.reduce((result, header, index) => {
                            const value = raw[i][index];

                            if (value instanceof Date) {
                                result[header] = moment(value).utc(true).toDate();
                            } else {
                                result[header] = trim(toString(value));
                            }

                            if (result[header] === '') {
                                result[header] = null;
                            }

                            return result;
                        }, {});

                        // Ignore empty row
                        if (Object.values(row).findIndex((v) => v != null && v !== '') !== -1) {
                            fileData.data.push(row);
                        }
                    }

                    resolve(fileData);
                } catch (error) {
                    reject(error);
                }
            };
        });

        reader.readAsBinaryString(file);

        return promise;
    }
}

export interface IFileData {
    name: string;
    size: number;
    type: string;
    lastModifiedDate: Date;
    headers: string[];
    data: object[];
}
